/*
 * Tyre size "tap menu" - Tyre Souq Arabia
 * ---------------------------------------
 * Turns the Width / Height / Rim Size fields in the homepage banner from native
 * <select> dropdowns into tappable option panels.
 *
 * Search contract is unchanged from the original handler in layout/theme.liquid:
 *
 *   /collections/all?filter.v.availability=1&filter.p.m.size_n.size_k=185/55R15
 *
 * with a second size value appended when a rear tyre is chosen (Shopify treats
 * repeated values on one filter as "either").
 *
 * Options are loaded a step at a time from the Width / Height / Rim Size
 * storefront filters, each request narrowed by what is already chosen, so the
 * lists only ever offer sizes the shop actually carries.
 *
 * NOTE: do not be tempted to read the combined "Tire Size" filter instead.
 * Shopify returns at most 100 values per filter and this catalogue has more
 * distinct sizes than that, so that list silently drops real sizes.
 * Width / height / rim are well under the limit and stay complete.
 *
 * Data source: templates/collection.sizeajax.liquid  (?view=sizeajax)
 * Styling:     assets/tyre-size-tap.css
 */
(function () {
  'use strict';

  var SIZE_PARAM = 'filter.p.m.size_n.size_k';
  var AVAILABILITY = 'filter.v.availability=1';
  var PARAM = {
    width: 'filter.p.m.width_n.width_k',
    height: 'filter.p.m.height_n.height_k',
    rim: 'filter.p.m.rim_n.rim_k',
  };
  var ORDER = ['width', 'height', 'rim'];
  var PLACEHOLDER = { width: 'Width', height: 'Height', rim: 'Rim Size' };

  var widgets = {};

  // Shown while a list is being fetched. Choosing a value auto-opens the next
  // field, and the old static "Loading..." line was easy to miss - so people
  // tapped the field to open it and closed it instead. Chips that move are
  // noticed straight away, and they show the shape of what is coming.
  function skeletonHtml() {
    var out = '<div class="tyre-tap-skeleton" aria-hidden="true">';
    for (var i = 0; i < 12; i++) out += '<i></i>';
    return out + '</div><span class="tyre-tap-sr">Loading sizes</span>';
  }

  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root.replace(/\/$/, '');
    }
    return '';
  }

  // Slashes are legal unencoded in a query value and the original handler sends
  // them raw - keep the URL identical to what the site already produces.
  function enc(s) {
    return encodeURIComponent(s).replace(/%2F/g, '/');
  }

  function numericSort(a, b) {
    var x = parseFloat(a);
    var y = parseFloat(b);
    if (isNaN(x) && isNaN(y)) return a < b ? -1 : a > b ? 1 : 0;
    if (isNaN(x)) return 1;
    if (isNaN(y)) return -1;
    if (x !== y) return x - y;
    return a < b ? -1 : a > b ? 1 : 0;
  }

  /* ---------- data ---------- */

  // In-flight and settled requests, keyed by URL. A list already fetched once
  // this page-view comes back in a microtask, so backing up to change a choice
  // is instant. A failed request is dropped so it can be retried.
  var cache = {};

  function fetchFilters(url) {
    if (cache[url]) return cache[url];
    // No Accept header here on purpose: Shopify answers alternate-view URLs
    // with a 404 when the request asks for text/plain.
    cache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        return JSON.parse(text.trim());
      })
      .catch(function (err) {
        delete cache[url];
        throw err;
      });
    return cache[url];
  }

  /* ---------- markup ---------- */

  var CARET =
    '<svg class="tyre-tap-caret" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 ' +
    '.708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>';

  function buildField(key, prefix) {
    var field = document.createElement('div');
    field.className = 'tyre-tap-field';
    field.setAttribute('data-tap-key', key);
    field.innerHTML =
      '<button type="button" class="tyre-tap-trigger" aria-haspopup="true" aria-expanded="false">' +
      '<span class="tyre-tap-value">' +
      PLACEHOLDER[key] +
      '</span>' +
      CARET +
      '</button>' +
      '<div class="tyre-tap-panel" hidden>' +
      '<p class="tyre-tap-panel-head">Select ' +
      prefix +
      PLACEHOLDER[key].toLowerCase() +
      '</p>' +
      '<div class="tyre-tap-options"></div>' +
      '</div>';
    return field;
  }

  /* ---------- widget ---------- */

  function TyreSizeTap(formEl) {
    var self = this;

    this.el = formEl;
    this.role = formEl.getAttribute('data-tyre-tap') || 'front';
    this.selection = { width: '', height: '', rim: '' };
    this.fields = {};
    this.openKey = null;

    var prefix = this.role === 'rear' ? 'rear ' : '';
    var anchor = formEl.querySelector('.tyre-tap-anchor');

    ORDER.forEach(function (key) {
      var field = buildField(key, prefix);
      if (anchor) {
        formEl.insertBefore(field, anchor);
      } else {
        formEl.appendChild(field);
      }
      self.fields[key] = {
        el: field,
        trigger: field.querySelector('.tyre-tap-trigger'),
        labelEl: field.querySelector('.tyre-tap-value'),
        panel: field.querySelector('.tyre-tap-panel'),
        options: field.querySelector('.tyre-tap-options'),
        loading: false,
        loadUrl: null,
      };
      self.fields[key].trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.toggle(key);
      });
    });

    // VIEW RESULT. Listening in the capture phase on an ancestor means this runs
    // before the original handler bound to the button itself, and stopping
    // propagation there keeps the two from both trying to navigate.
    this.resultButtons = [];
    var target = formEl.getAttribute('data-result-target');
    if (target) {
      var scope = formEl.closest('year-search') || document.body;
      Array.prototype.forEach.call(scope.querySelectorAll(target), function (btn) {
        self.resultButtons.push(btn);
      });
      scope.addEventListener(
        'click',
        function (e) {
          var btn = e.target && e.target.closest ? e.target.closest(target) : null;
          if (!btn || !scope.contains(btn)) return;
          e.preventDefault();
          e.stopPropagation();
          self.go();
        },
        true
      );
    }

    document.addEventListener('click', function (e) {
      if (!formEl.contains(e.target)) self.closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeAll();
    });

    this.setEnabled('height', false);
    this.setEnabled('rim', false);
    this.syncResultButtons();
    this.load('width');
  }

  TyreSizeTap.prototype.setEnabled = function (key, on) {
    var f = this.fields[key];
    if (!f) return;
    f.el.classList.toggle('is-disabled', !on);
    f.trigger.disabled = !on;
  };

  TyreSizeTap.prototype.toggle = function (key) {
    if (this.openKey === key) {
      // Choosing a value auto-opens the next field while its list is still
      // loading. Someone who has not noticed that taps the field to open it -
      // which, as a plain toggle, would close it instead. While a field is
      // loading, its own trigger only ever keeps it open.
      if (this.fields[key] && this.fields[key].loading) return;
      this.closeAll();
      return;
    }
    this.closeAll();
    var f = this.fields[key];
    if (!f || f.trigger.disabled) return;
    f.panel.hidden = false;
    f.el.classList.add('is-open');
    f.trigger.setAttribute('aria-expanded', 'true');
    this.openKey = key;
  };

  TyreSizeTap.prototype.closeAll = function () {
    var self = this;
    ORDER.forEach(function (key) {
      var f = self.fields[key];
      if (!f) return;
      f.panel.hidden = true;
      f.el.classList.remove('is-open');
      f.trigger.setAttribute('aria-expanded', 'false');
    });
    this.openKey = null;
  };

  // Everything already chosen upstream of `key`, as filter params.
  TyreSizeTap.prototype.upstreamParams = function (key) {
    var parts = [];
    var stop = ORDER.indexOf(key);
    for (var i = 0; i < stop; i++) {
      var k = ORDER[i];
      if (this.selection[k]) parts.push(PARAM[k] + '=' + enc(this.selection[k]));
    }
    return parts;
  };

  TyreSizeTap.prototype.load = function (key) {
    var self = this;
    var f = this.fields[key];
    if (!f) return;

    var qs = [AVAILABILITY].concat(this.upstreamParams(key));
    qs.push('view=sizeajax');
    var url = root() + '/collections/all?' + qs.join('&');

    function extract(data) {
      var group = null;
      (data.filters || []).forEach(function (g) {
        if (g.param === PARAM[key]) group = g;
      });
      var values = (group && group.values ? group.values : []).filter(function (v) {
        return v.count > 0;
      });
      values.sort(function (a, b) {
        return numericSort(a.value, b.value);
      });
      return values;
    }

    // Already fetched this page-view: it resolves in a microtask, so showing the
    // skeleton would only make it flash. Go straight to the options.
    if (!cache[url]) {
      f.loading = true;
      f.el.classList.add('is-loading');
      f.options.innerHTML = skeletonHtml();
    }
    f.loadUrl = url;

    fetchFilters(url)
      .then(function (data) {
        // A later request for this field has overtaken this one.
        if (f.loadUrl !== url) return;
        f.loading = false;
        f.el.classList.remove('is-loading');
        self.render(key, extract(data));
      })
      .catch(function () {
        if (f.loadUrl !== url) return;
        f.loading = false;
        f.el.classList.remove('is-loading');
        f.options.innerHTML =
          '<p class="tyre-tap-note tyre-tap-note--error">Could not load sizes. Please try again.</p>';
      });
  };

  // A few tyres have no aspect ratio (the "195 R14" style stock) and store a
  // height of "R". Showing a bare "R" means nothing to a customer, so it reads
  // as "None" - the underlying value is untouched.
  function displayLabel(key, label) {
    if (key === 'height' && !/^\d/.test(label)) return 'None';
    return label;
  }

  TyreSizeTap.prototype.render = function (key, values) {
    var self = this;
    var f = this.fields[key];

    f.options.innerHTML = '';

    if (!values.length) {
      f.options.innerHTML = '<p class="tyre-tap-note">No sizes available.</p>';
      return;
    }

    values.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tyre-tap-option';
      if (self.selection[key] === v.value) btn.classList.add('is-selected');
      btn.setAttribute('data-value', v.value);
      var shown = displayLabel(key, v.label);
      btn.innerHTML =
        '<span class="tyre-tap-option-label"></span><span class="tyre-tap-option-count"></span>';
      btn.firstChild.textContent = shown;
      btn.lastChild.textContent = v.count;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.choose(key, v.value, shown);
      });
      f.options.appendChild(btn);
    });
  };

  TyreSizeTap.prototype.choose = function (key, value, label) {
    var idx = ORDER.indexOf(key);

    this.selection[key] = value;
    this.fields[key].labelEl.textContent = label;
    this.fields[key].el.classList.add('has-value');

    // Anything chosen further down the chain is no longer valid.
    for (var i = idx + 1; i < ORDER.length; i++) {
      var next = ORDER[i];
      this.selection[next] = '';
      this.fields[next].labelEl.textContent = PLACEHOLDER[next];
      this.fields[next].el.classList.remove('has-value');
      this.fields[next].el.classList.remove('is-loading');
      this.fields[next].loading = false;
      // Drops any request still in flight for this field on the floor.
      this.fields[next].loadUrl = null;
      this.fields[next].options.innerHTML = '';
      this.setEnabled(next, false);
    }

    this.closeAll();
    this.syncResultButtons();

    // Open the next field straight away so the flow keeps moving with one tap.
    if (idx + 1 < ORDER.length) {
      var nextKey = ORDER[idx + 1];
      this.setEnabled(nextKey, true);
      this.load(nextKey);
      this.toggle(nextKey);
    }
  };

  TyreSizeTap.prototype.isComplete = function () {
    return !!(this.selection.width && this.selection.height && this.selection.rim);
  };

  // The size string(s) to search for. Normally one: the same value the original
  // handler builds, e.g. "185/55R15".
  TyreSizeTap.prototype.sizeValues = function () {
    if (!this.isComplete()) return [];
    var w = this.selection.width;
    var h = this.selection.height;
    var r = this.selection.rim;
    var main = w + '/' + h + 'R' + r;

    // A handful of products (the "195 R14" style stock) have a non-numeric
    // height of "R". Most are stored as "195/RR14", but at least one is stored
    // as "205R16". Send both spellings and let Shopify match whichever exists,
    // rather than guessing and returning an empty page.
    if (!/^\d/.test(h)) return [main, w + 'R' + r];
    return [main];
  };

  TyreSizeTap.prototype.syncResultButtons = function () {
    var ready = this.isComplete();
    this.resultButtons.forEach(function (btn) {
      btn.classList.toggle('is-disabled', !ready);
      btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    });
  };

  TyreSizeTap.prototype.go = function () {
    if (!this.isComplete()) {
      // Nudge the customer to the first thing still missing.
      for (var i = 0; i < ORDER.length; i++) {
        if (!this.selection[ORDER[i]]) {
          this.toggle(ORDER[i]);
          return;
        }
      }
      return;
    }

    var parts = [AVAILABILITY];
    var add = function (v) {
      parts.push(SIZE_PARAM + '=' + enc(v));
    };

    this.sizeValues().forEach(add);

    // A rear tyre is added as further values on the same filter, which Shopify
    // treats as "any of these" - same as the original behaviour.
    var rear = widgets.rear;
    if (this.role === 'front' && rear && rear.isComplete()) {
      var rearVisible =
        rear.el.offsetParent !== null || rear.el.getClientRects().length > 0;
      if (rearVisible) rear.sizeValues().forEach(add);
    }

    window.location.href = root() + '/collections/all?' + parts.join('&');
  };

  /* ---------- boot ---------- */

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-tyre-tap]'),
      function (el) {
        if (el.__tyreTap) return;
        el.__tyreTap = new TyreSizeTap(el);
        widgets[el.__tyreTap.role] = el.__tyreTap;
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
